export const data = {
    datasets: [{
        yAxisID: 'A',
        type: 'bar',
        label: '금액',
    }, {
        yAxisID: 'B',
        type: 'line',
        label: '건수',
    }],
};

export const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
        y: {
            id: 'A',
            type: 'linear',
            position: 'left',
        },
    },
    plugins: {
        datalabels: {
            formatter: function (value, context) {
                if (context.dataset.label === '금액') {
                    if (context.dataset.data.length < 15) {
                        return `${(value / 100000000).toFixed(2) + " 억원"}`;
                    } else {
                        if (value > 300000000) {
                            return `${(value / 100000000).toFixed(2) + " 억원"}`;
                        } else {
                            return null
                        }
                    }
                } else if (context.dataset.label === '건수') {
                    return null
                }
            }
        }
    },
    onHover: (event, chartElement) => {
        event.native.target.style.cursor = chartElement[0] ? 'pointer' : 'default';
    }
}
